export default "__VITE_ASSET__1RJRwakb__"